/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Orders_Filter_RentalsInputs */

const en_seller_orders_filter_rentals = /** @type {(inputs: Seller_Orders_Filter_RentalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rentals`)
};

const es_seller_orders_filter_rentals = /** @type {(inputs: Seller_Orders_Filter_RentalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquileres`)
};

const fr_seller_orders_filter_rentals = /** @type {(inputs: Seller_Orders_Filter_RentalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locations`)
};

const de_seller_orders_filter_rentals = /** @type {(inputs: Seller_Orders_Filter_RentalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vermietungen`)
};

const id_seller_orders_filter_rentals = /** @type {(inputs: Seller_Orders_Filter_RentalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyewaan`)
};

/** @type {(inputs: Seller_Orders_Filter_RentalsInputs) => LocalizedString} */
const ja_seller_orders_filter_rentals = en_seller_orders_filter_rentals;

/** @type {(inputs: Seller_Orders_Filter_RentalsInputs) => LocalizedString} */
const zh_seller_orders_filter_rentals = en_seller_orders_filter_rentals;

/** @type {(inputs: Seller_Orders_Filter_RentalsInputs) => LocalizedString} */
const ar_seller_orders_filter_rentals = en_seller_orders_filter_rentals;

/** @type {(inputs: Seller_Orders_Filter_RentalsInputs) => LocalizedString} */
const it_seller_orders_filter_rentals = en_seller_orders_filter_rentals;

/** @type {(inputs: Seller_Orders_Filter_RentalsInputs) => LocalizedString} */
const ru_seller_orders_filter_rentals = en_seller_orders_filter_rentals;

/** @type {(inputs: Seller_Orders_Filter_RentalsInputs) => LocalizedString} */
const pt_seller_orders_filter_rentals = en_seller_orders_filter_rentals;

/** @type {(inputs: Seller_Orders_Filter_RentalsInputs) => LocalizedString} */
const ko_seller_orders_filter_rentals = en_seller_orders_filter_rentals;

/**
* | output |
* | --- |
* | "Rentals" |
*
* @param {Seller_Orders_Filter_RentalsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_orders_filter_rentals = /** @type {((inputs?: Seller_Orders_Filter_RentalsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Orders_Filter_RentalsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_orders_filter_rentals(inputs)
	if (locale === "es") return es_seller_orders_filter_rentals(inputs)
	if (locale === "fr") return fr_seller_orders_filter_rentals(inputs)
	if (locale === "de") return de_seller_orders_filter_rentals(inputs)
	if (locale === "ja") return ja_seller_orders_filter_rentals(inputs)
	if (locale === "zh") return zh_seller_orders_filter_rentals(inputs)
	if (locale === "ar") return ar_seller_orders_filter_rentals(inputs)
	if (locale === "id") return id_seller_orders_filter_rentals(inputs)
	if (locale === "it") return it_seller_orders_filter_rentals(inputs)
	if (locale === "ru") return ru_seller_orders_filter_rentals(inputs)
	if (locale === "pt") return pt_seller_orders_filter_rentals(inputs)
	return ko_seller_orders_filter_rentals(inputs)
});